import React, { createContext, useContext, useEffect, useState } from "react";
import { connectSocket, disconnectSocket, RealtimeSocket } from "../../config/socket";

interface SocketContextProps {
  socket: RealtimeSocket | null;
}

const SocketContext = createContext<SocketContextProps>({ socket: null });

export const SocketProvider: React.FC<{
  organizationId: string;
  userId: string;
  children: React.ReactNode;
}> = ({ organizationId, userId, children }) => {
  const [ socket, setSocket ] = useState<RealtimeSocket | null>( null );

  useEffect(() => {
    // Compatibilidade incremental:
    // - namespace legado continua sendo organization-{organizationId}
    // - a implementacao concreta vem de connectSocket() e pode ser SSE ou Socket.IO por env
    if( organizationId ) {
      const s = connectSocket( organizationId, userId );
      setSocket( s );
    } else {
      disconnectSocket();
      setSocket( null );
    }

    return () => {
      disconnectSocket();
      setSocket( null );
    };
  }, [ organizationId, userId ]);

  return (
    <SocketContext.Provider value={{ socket }}>
      { children }
    </SocketContext.Provider>
  );
};

export const useSocket = () => useContext( SocketContext );
